{
  "people": "Gens",
  "teams": "Équipes",
  "surnameAlphabetical": "Nom de famille A-Z",
  "teamsAlphabetical": "Équipes de A à Z",
  "addTeamMember": "Ajouter un membre de l'équipe",
  "addSelectedToTeam": "Ajouter la sélection à l'équipe",
  "allPeople": "Toutes les personnes",
  "removeTeamLeaderMessage": "Cette personne ne pourra plus modifier ni ajouter/supprimer des membres de l'équipe.",
  "removeTeamLeader": "Supprimer le statut de chef d'équipe",
  "addTeamLeaderMessage": "Cette personne pourra modifier et ajouter/supprimer des membres de l'équipe.",
  "addTeamLeader": "Ajouter le statut de chef d'équipe",
  "add_people": {
    "add_user": "Ajouter un utilisateur",
    "invite_people_to_the_project": "Envoyer des invitations à rejoindre le projet",
    "email": "Courrier électronique",
    "team": "L'équipe",
    "separate_comma": "Séparez les adresses multiples par une virgule",
    "add_invitee_team": "Ajouter un ou plusieurs invités à une équipe",
    "add_more": "Ajoutez-en plus",
    "project_admin": "Administrateur de projet",
    "sso": "Activer SSO"
  },
  "remove_people": {
    "remove_user": "Supprimer un utilisateur",
    "remove_user_title": "Supprimer cet utilisateur du projet",
    "remove_user_message": "Cela désactivera le compte de l'utilisateur sélectionné sur le projet et il ne pourra plus se connecter.",
    "remove_user_message_continue": "Êtes-vous sûr de vouloir continuer ?",
    "remove_people_success": "L'utilisateur a été supprimé du projet avec succès"
  },
  "reset_password": {
    "reset_password_title": "Envoyer un lien pour réinitialiser le mot de passe",
    "reset_password_message": "Cela enverra un lien de réinitialisation du mot de passe aux personnes que vous avez sélectionnées.",
    "reset_password_message_continue": "Aimerais-tu continuer ?",
    "reset_password_success": "Le lien de réinitialisation du mot de passe a été envoyé avec succès aux personnes sélectionnées"
  },
  "sso": {
    "title": "Activer le SSO",
    "confirm": "Cela activera le SSO pour les personnes sélectionnées.",
    "continue": "Aimerais-tu continuer ?",
    "success": "Le SSO a été activé avec succès pour les personnes sélectionnées"
  },
  "sso_disable": {
    "title": "Désactiver le SSO",
    "confirm": "Les utilisateurs sélectionnés ne pourraient plus se connecter via Single Sign On et devront s'authentifier à l'aide d'un mot de passe.",
    "continue": "Aimerais-tu continuer ?",
    "success": "Le SSO a été désactivé avec succès pour certaines personnes"
  },
  "removeFromTeamMessage1": "Cette personne ne fera plus partie de l'équipe et perdra toutes les autorisations de visualisation et de modification associées à cette équipe.",
  "removeFromTeamMessage2": "Êtes-vous sûr de vouloir continuer ?",
  "removeFromTeamTitle": "Supprimer cette personne de l'équipe",
  "removeFromTeamOverflowOption": "Supprimer de l'équipe",
  "createANewTeam": "Créez une nouvelle équipe",
  "nameOfTeam": "Nom de l'équipe",
  "createNewTeam": "Créer une nouvelle équipe",
  "teamLeader": "Chef d'équipe",
  "toasts": {
    "add_team_success": "Équipe créée avec succès",
    "add_team_error": "Impossible de créer une équipe",
    "invite_success": "Invitation (s) envoyée (s) avec succès",
    "invite_error": "Impossible d'envoyer l'invitation car {{ reason }}",
    "removeFromTeamSuccess": "Supprimé de l'équipe avec succès",
    "removeFromTeamError": "Impossible de se retirer de l'équipe",
    "setTeamLeaderSuccess": "Définir avec succès le statut de chef d'équipe",
    "setTeamLeaderError": "Impossible de définir le statut de chef d'équipe",
    "deleteTeamSuccess": "Équipe supprimée avec succès",
    "deleteTeamError": "Impossible de supprimer l'équipe"
  },
  "amount_teams_selected": "{{ amount }} Équipes sélectionnées",
  "invalid_email_address": "Adresse e-mail non valide",
  "one_or_more_email_not_valid": "Un ou plusieurs e-mails ne sont pas valides",
  "select_one_team": "Veuillez sélectionner une ou plusieurs équipes",
  "deleteTeamTitle": "Supprimer l'équipe",
  "deleteTeamMessage": "Êtes-vous sûr de vouloir supprimer l'équipe : {{ team }}"
}